import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";

export default class extends Controller {
  static targets = ["select"];

  connect() {
    const urlParams = new URLSearchParams(window.location.search);
    const hasCustomDates = urlParams.has('custom_start_date') && urlParams.has('custom_end_date');
    
    if (hasCustomDates && this.selectTarget.value !== 'custom') {
      this.selectTarget.value = 'custom';
    }
    
    this.toggleCustomDateFields();
  }

  toggle() {
    this.toggleCustomDateFields();
  }

  toggleCustomDateFields() {
    const select = this.selectTarget;
    const container = document.getElementById('custom_date_range_container');
    
    console.log('toggleCustomDateFields called', select?.value, container);
    
    if (select && container) {
      if (select.value === 'custom') {
        container.style.display = 'block';
        console.log('Container shown, initializing datepicker...');
        // Esperar un momento para que el DOM se actualice y luego inicializar el datepicker
        setTimeout(() => {
          const input = document.getElementById('custom_date_range');
          console.log('Input found:', input);
          if (input) {
            // Verificar si ya tiene flatpickr inicializado
            const hasFlatpickr = input._flatpickr || input.classList.contains('flatpickr-input');
            if (!hasFlatpickr) {
              // Obtener fechas iniciales si existen en los parámetros de la URL o en el input
              let defaultDate = null;
              const inputValue = input.value;
              if (inputValue && inputValue.includes(' - ')) {
                const dates = inputValue.split(' - ');
                if (dates.length === 2) {
                  const startDateStr = dates[0].trim();
                  const endDateStr = dates[1].trim();
                  // Parsear fechas evitando problemas de zona horaria
                  // Usar formato YYYY-MM-DD y crear Date en hora local
                  const parseLocalDate = (dateStr) => {
                    const [year, month, day] = dateStr.split('-').map(Number);
                    return new Date(year, month - 1, day);
                  };
                  defaultDate = [parseLocalDate(startDateStr), parseLocalDate(endDateStr)];
                }
              }
              
              const options = {
                mode: "range",
                dateFormat: "Y-m-d",
                defaultDate: defaultDate,
                allowInput: false,
                locale: {
                  firstDayOfWeek: 1,
                  weekdays: {
                    shorthand: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
                    longhand: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"]
                  },
                  months: {
                    shorthand: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
                    longhand: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]
                  },
                  rangeSeparator: " - "
                },
                onChange: (selectedDates, dateStr, instance) => {
                  if (selectedDates.length === 2) {
                    const form = container.closest('form');
                    if (form) {
                      let startInput = form.querySelector('#hidden_start_date');
                      if (!startInput) {
                        startInput = document.createElement('input');
                        startInput.type = 'hidden';
                        startInput.id = 'hidden_start_date';
                        startInput.name = 'custom_start_date';
                        form.appendChild(startInput);
                      }
                      startInput.value = this.formatDate(selectedDates[0]);

                      let endInput = form.querySelector('#hidden_end_date');
                      if (!endInput) {
                        endInput = document.createElement('input');
                        endInput.type = 'hidden';
                        endInput.id = 'hidden_end_date';
                        endInput.name = 'custom_end_date';
                        form.appendChild(endInput);
                      }
                      endInput.value = this.formatDate(selectedDates[1]);
                    }
                  }
                }
              };
              
              try {
                console.log('Initializing flatpickr with defaultDate:', defaultDate);
                const picker = flatpickr(input, options);
                console.log('Flatpickr initialized:', picker);
                
                // Si hay fechas por defecto, asegurarse de que se muestren correctamente
                if (defaultDate && defaultDate.length === 2) {
                  picker.setDate(defaultDate, false);
                }
              } catch (error) {
                console.error('Error al inicializar flatpickr:', error);
              }
            }
          }
        }, 100);
      } else {
        container.style.display = 'none';
        const input = document.getElementById('custom_date_range');
        if (input) {
          input.value = '';
          // Destruir flatpickr si existe
          if (input._flatpickr) {
            input._flatpickr.destroy();
            input._flatpickr = null;
          }
        }
      }
    }
  }

  formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
}
